// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --first-color: #2e2e41;
  --second-color: #5b85ff;
  --third-color: #434354;
  --text-color: #fff;
  --box-shadow: 0 5px 25px rgb(2, 2, 2, 0.1);
  --text-shadow: 0 5px 25px rgb(2, 2, 2, 0.1);
}
.main-container {
  position: fixed;
  top: 85px;
  z-index: 99;
}
.tab-nav-bar {
  position: fixed;
  width: 100%;
  background-color: var(--third-color);
}
.tab-navigation {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: fit-content;
  margin: 0 auto;
}
.tab-menu {
  color: var(--text-color);
  list-style: none;
  background: var(--third-color);
  white-space: nowrap;
  overflow-x: auto;
  -webkit-user-select: none;
          user-select: none;
  scroll-behavior: smooth;
  margin-bottom: 0px;
}
.tab-menu.dragging {
  scroll-behavior: unset;
  cursor: grab;
}
.tab-menu::-webkit-scrollbar {
  display: none;
}
.tab-btn {
  color: var(--text-color);
  display: inline-block;
  font-size: 1em;
  font-weight: 400;
  margin: 6px;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: 0.3s ease;
}
.tab-btn a {
  text-decoration: none;
  color: aliceblue;
}
.tab-menu.dragging .tab-btn {
  pointer-events: none;
}
.tab-btn:hover {
  background: var(--first-color);
}
.tab-btn.active {
  background: var(--second-color);
}
.left-btn, .right-btn {
  position: absolute;
  color: var(--text-color);
  text-align: center;
  font-size: 41px;
  cursor: pointer;
}
.left-btn {
  left: 0;
  background: linear-gradient(to left, transparent, var(--first-color) 10%);
  display: none;
}
.right-btn {
  right: 0;
  background: linear-gradient(to right, transparent, var(--first-color) 10%);
}
/* ======= Tab Content ======= */
@media (max-width: 768px) {
  .tab-btn {
    font-size: 1.2em;
  }
  .tab-btn a {
    font-size: 17.5px;
  }
  .left-btn, .right-btn {
    font-size: 2.5em;
  }
  .left-btn {
    left: 0;
    background: linear-gradient(to left, transparent, var(--first-color) 50%);
    display: none;
  }
  .right-btn {
    right: 0;
    background: linear-gradient(to right, transparent, var(--first-color) 50%);
  }
}`, "",{"version":3,"sources":["webpack://./src/css/nav_bar.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,SAAS;EACT,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,OAAO;EACP,yEAAyE;EACzE,aAAa;AACf;AACA;EACE,QAAQ;EACR,0EAA0E;AAC5E;AACA,gCAAgC;AAChC;EACE;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,OAAO;IACP,yEAAyE;IACzE,aAAa;EACf;EACA;IACE,QAAQ;IACR,0EAA0E;EAC5E;AACF","sourcesContent":[":root {\n  --first-color: #2e2e41;\n  --second-color: #5b85ff;\n  --third-color: #434354;\n  --text-color: #fff;\n  --box-shadow: 0 5px 25px rgb(2, 2, 2, 0.1);\n  --text-shadow: 0 5px 25px rgb(2, 2, 2, 0.1);\n}\n.main-container {\n  position: fixed;\n  top: 85px;\n  z-index: 99;\n}\n.tab-nav-bar {\n  position: fixed;\n  width: 100%;\n  background-color: var(--third-color);\n}\n.tab-navigation {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: fit-content;\n  margin: 0 auto;\n}\n.tab-menu {\n  color: var(--text-color);\n  list-style: none;\n  background: var(--third-color);\n  white-space: nowrap;\n  overflow-x: auto;\n  user-select: none;\n  scroll-behavior: smooth;\n  margin-bottom: 0px;\n}\n.tab-menu.dragging {\n  scroll-behavior: unset;\n  cursor: grab;\n}\n.tab-menu::-webkit-scrollbar {\n  display: none;\n}\n.tab-btn {\n  color: var(--text-color);\n  display: inline-block;\n  font-size: 1em;\n  font-weight: 400;\n  margin: 6px;\n  padding: 10px 20px;\n  border-radius: 10px;\n  cursor: pointer;\n  user-select: none;\n  transition: 0.3s ease;\n}\n.tab-btn a {\n  text-decoration: none;\n  color: aliceblue;\n}\n.tab-menu.dragging .tab-btn {\n  pointer-events: none;\n}\n.tab-btn:hover {\n  background: var(--first-color);\n}\n.tab-btn.active {\n  background: var(--second-color);\n}\n.left-btn, .right-btn {\n  position: absolute;\n  color: var(--text-color);\n  text-align: center;\n  font-size: 41px;\n  cursor: pointer;\n}\n.left-btn {\n  left: 0;\n  background: linear-gradient(to left, transparent, var(--first-color) 10%);\n  display: none;\n}\n.right-btn {\n  right: 0;\n  background: linear-gradient(to right, transparent, var(--first-color) 10%);\n}\n/* ======= Tab Content ======= */\n@media (max-width: 768px) {\n  .tab-btn {\n    font-size: 1.2em;\n  }\n  .tab-btn a {\n    font-size: 17.5px;\n  }\n  .left-btn, .right-btn {\n    font-size: 2.5em;\n  }\n  .left-btn {\n    left: 0;\n    background: linear-gradient(to left, transparent, var(--first-color) 50%);\n    display: none;\n  }\n  .right-btn {\n    right: 0;\n    background: linear-gradient(to right, transparent, var(--first-color) 50%);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
